module.exports = __webpack_public_path__ + "ffd2c5a506cf1d39bd9bc9a8b036a05c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/eg.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/eg.svg
// module chunks = 0